import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EdpService } from '../services/edp.service';
import { faFileLines, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { Config } from 'datatables.net';

@Component({
  selector: 'app-expediente',
  templateUrl: './expediente.component.html',
  styleUrls: ['./expediente.component.css'],
  standalone: false,
})
export class ExpedienteComponent implements OnInit, OnDestroy {
  state$: Observable<object> | undefined;

  // Datatables
  dtOptions: Config = {};
  dtTrigger: Subject<any> = new Subject<any>();
  // Almacenar datos de expediente
  expediente: any = [];
  admin: boolean = false;
  // Iconos FontAwesome
  icon1 = faFileLines;
  icon2 = faPencilAlt;

  idGrupo: string = '';
  tutor: string = '';

  constructor(private service: EdpService, private route: Router) {}

  ngOnInit(): void {
    this.idGrupo = window.history.state.idGrupo;
    this.tutor = window.history.state.tutor;

    if (!this.idGrupo) {
      this.route.navigate(['/']);
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      language: {
        processing: 'Procesando...',
        lengthMenu: 'Mostrar _MENU_ alumnos',
        zeroRecords: 'No se encontraron resultados',
        emptyTable: 'Ningún dato disponible en esta tabla',
        infoEmpty: 'Mostrando alumnos del 0 al 0 de un total de 0 alumnos',
        infoFiltered: '(filtrado de un total de _MAX_ alumnos)',
        search: 'Buscar:',
        loadingRecords: 'Cargando...',
        paginate: {
          first: 'Primero',
          last: 'Último',
          next: 'Siguiente',
          previous: 'Anterior',
        },
        info: 'Mostrando _START_ a _END_ de _TOTAL_ alumnos',
      },
      autoWidth: true,
    };

    if (this.service.comprobarSesion()) {
      this.admin = this.service.UsuarioRegistra();

      this.service
        .obtenerExpediente(sessionStorage.getItem('edpp-token'), this.idGrupo)
        .subscribe(
          async (data) => {
            if (data[0].Error) {
              alert('La sesión ha caducado.\nVuelve para iniciar sesión.');
              this.route.navigate(['/login']);
            } else {
              this.expediente = await data;
              this.dtTrigger.next(false);
            }
          },
          (err) => {
            if (!err.ok)
              alert('Error del servidor: Vuelve a intentarlo más tarde.');
          }
        );
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  volverAGrupo() {
    this.route.navigate(['/']);
  }

  registrar(matricula: string, nombre: string) {
    this.route.navigateByUrl('/sesion', {
      state: { matricula, nombre, idGrupo: this.idGrupo, tutor: this.tutor },
    });
  }

  verSesion(matricula: string, nombre: string) {
    this.route.navigateByUrl('/sesion-individual', {
      state: { matricula, nombre, idGrupo: this.idGrupo, tutor: this.tutor },
    });
  }
}
